import { render, staticRenderFns } from "./currencies.vue?vue&type=template&id=004a891a"
import script from "./currencies.vue?vue&type=script&lang=js"
export * from "./currencies.vue?vue&type=script&lang=js"
import style0 from "./currencies.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/system/currencies.vue
// module id = uQmm
// module chunks = 0